export var ChartColors;
(function (ChartColors) {
    ChartColors["AQUAFRESH"] = "#81ECEC";
    ChartColors["MOJITO"] = "#55EFC4";
    ChartColors["CHLORINE"] = "#00CEC9";
    ChartColors["AVOCADO"] = "#00B894";
    ChartColors["CLEAR_SKY"] = "#74B8FF";
    ChartColors["CERULEAN"] = "#0984E3";
    ChartColors["TARO"] = "#A29BFE";
    ChartColors["AMETHYST"] = "#6C5CE7";
    ChartColors["BUTTER"] = "#FFEAA7";
    ChartColors["SUNNY_DAY"] = "#FDCB6E";
    ChartColors["GRAPEFRUIT"] = "#FAB1A0";
    ChartColors["PUMPKIN_SPICE"] = "#E17055";
    ChartColors["FLAMINGO"] = "#FF7676";
    ChartColors["BUBBLE_GUM"] = "#FD79A8";
    ChartColors["PEPTO_BISMOL"] = "#E84493";
    ChartColors["SRIRACHA"] = "#D63131";
    ChartColors["NICKEL"] = "#B2BEC3";
    ChartColors["FOG"] = "#DFE6E9";
    ChartColors["MONDAY"] = "#636E72";
    ChartColors["CHARCOAL"] = "#2D3436";
})(ChartColors || (ChartColors = {}));
